import { Component, OnInit } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';

@Component({
    selector: 'customer-prelogin',
    templateUrl: 'pre-login.component.html',
    styleUrls: ['pre-login.component.scss']
})
export class CustomerPreloginComponent implements OnInit {
    menuId: number = 1;
    constructor(private router: Router, private activatedRoute: ActivatedRoute) {
        //this.apiResponse.Status = false;
    }

    ngOnInit() {
        window.scrollTo(0, 0);
        //this.commonEndpoint.CheckIsUserAlreadyLogin();
        this.activatedRoute.queryParams.subscribe(params => {
            if (params["id"] && +params["id"]==3) {
                this.menuId = 3;
            }
        })
        this.CheckIsUserAlreadyLogin();
    }
    preLoginMenuOptionClick(value) {
        this.menuId = value;
    }
    CheckIsUserAlreadyLogin() {
        // debugger
        if (localStorage.getItem('currentUser') != null) {
            if(localStorage.getItem('EntityType') != null && localStorage.getItem('EntityType') != "102")
            this.router.navigate(['/profile/dashboard']);
            else  if(localStorage.getItem('EntityType') != null && localStorage.getItem('EntityType') != "115")
            {
                this.router.navigate(['/secure']);
            }else
            this.router.navigate(['/merchant']);
        }
    }

        clickprivacy() {
  this.router.navigate(['/privacypolicy']);
        }

}


// WEBPACK FOOTER //
// ./src/app/components/customer-pre-login/pre-login.component.ts